import type { SVGProps } from 'react';
const SvgOfficeWorkerStreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Office Worker Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M5.286 5.286a2.312 2.312 0 1 0 0-4.625 2.312 2.312 0 0 0 0 4.625" />
      <path d="M7.268 17.84H3.304l-.661-5.617H.66V9.911a4.625 4.625 0 0 1 9.203-.661M9.677 13.175c0-.644.522-1.166 1.166-1.166h5.83c.644 0 1.166.522 1.166 1.166v3.498c0 .644-.522 1.166-1.166 1.166h-5.83a1.166 1.166 0 0 1-1.166-1.166z" />
      <path d="M12.163 12.01v-1.191c0-.73.591-1.321 1.321-1.321h.545c.73 0 1.322.591 1.322 1.321v1.19" />
    </g>
  </svg>
);
export default SvgOfficeWorkerStreamlineCore;
